import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=b570047e&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=b570047e&lang=scss&scoped=true&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=b570047e&scoped=true&lang=css&"
import style2 from "./Dashboard.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b570047e",
  null
  
)

export default component.exports